import { render, staticRenderFns } from "./QuoteSection.vue?vue&type=template&id=df3a3dc0&"
import script from "./QuoteSection.vue?vue&type=script&lang=js&"
export * from "./QuoteSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports